import { apiClient, handleApiRequest } from './client'

export interface PlanTeacher {
  id: string
  last_name: string
  first_name: string
  teacher_code: string
}

export interface StandardRow {
  entry_id: string
  weekday: string
  start: string
  end: string
  lesson_number?: number | null
  subject: string
  class_name: string
  room: string
  substitution_excluded?: boolean
}

export interface DeviationRow {
  lesson_id: string
  request_id: string
  entry_id: string
  date: string
  iso_year: number
  iso_week: number
  weekday: string
  start: string
  end: string
  sign: 'minus' | 'plus'
  open: boolean
  subject: string
  class_name: string
  room: string
  other_name: string
  label: string
  substitution_excluded?: boolean
}

export interface WeekChip {
  iso_year: number
  iso_week: number
  minus: number
  plus: number
}

export interface PlanSlot {
  id: string
  slot_number?: number | null
  name?: string | null
  start: string
  end: string
  is_break?: boolean
}

export interface TemplateRow {
  label: string
  lesson?: number | null
}

export interface TemplateGrid {
  days: string[]
  rows: TemplateRow[]
}

export interface EffectivePlan {
  school_year: string
  date_from: string
  date_to: string
  teacher: PlanTeacher
  show_saturday: boolean
  slots?: PlanSlot[]
  template_grid?: TemplateGrid
  standard: StandardRow[]
  deviations: DeviationRow[]
  weeks: WeekChip[]
}

export const effectivePlanApi = {
  listTeachers: () =>
    handleApiRequest<{ teachers: PlanTeacher[] }>(apiClient.get('/api/v1/effective-plan/teachers')),

  get: (teacherId: string) =>
    handleApiRequest<EffectivePlan>(apiClient.get('/api/v1/effective-plan', { params: { teacher_id: teacherId } })),
}
